import { defineNuxtPlugin } from '#app';
import domPurifyDirective from '~/directives/domPurify';

export default defineNuxtPlugin((nuxtApp) => {
  // Register the directive globally
  nuxtApp.vueApp.directive('dom-purify', domPurifyDirective);
});
